import styled from "styled-components";
import { Tooltip } from "primereact/tooltip";
import { Icon } from "@vds/icons";

// -- Styled components for Vehicle/Asset column --

export const VehicleRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const VehicleIcon = styled.img`
  margin-right: 8px;
  flex-shrink: 0;
  cursor: pointer;
`;

export const VehicleInfoWrapper = styled.div`
  padding-left: 4px;
`;

export const VehicleNameLinkButton = styled.button`
  all: unset;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  font-weight: bold;
  font-size: 14px;
  text-decoration: underline;
  color: #000;
`;

export const VehicleNameRow = styled.div`
  padding-top: 4px;
`;

export const VehicleSubText = styled.div`
  padding-top: ${(props) => props.$gap || "4px"};
  font-size: 12px;
`;

export const TraitsRow = styled.div`
  padding-top: 4px;
`;

// -- Styled components for Install Type column --

export const InstallTypeRow = styled.div`
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const NotBilledIconWrapper = styled.div`
  position: relative;
  display: inline-block;
`;

export const ConvertedLabel = styled.div`
  color: #ff8027;
`;

export const TooltipText = styled.div`
  font-size: 12px;
`;

// -- Styled components for Vehicle Note column --

export const VehicleNoteHeaderWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
`;

export const InfoIconImg = styled.img`
  cursor: pointer;
`;

export const TruncatedText = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
`;

export const CoinImg = styled.img`
  cursor: pointer;
`;

// -- Shared styled components --

export const IconWrapper = styled.div`
  background-color: ${(props) => props.color || "#f2f2f2"};
  border-color: #e0e0e0;
  padding: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 20px;
  width: 20px;
  margin-right: 4px;
  cursor: pointer;
`;

export const StrikeThroughLine = styled.div`
  position: absolute;
  top: 40%;
  left: 0;
  width: 100%;
  height: 1px;
  background-color: black;
  transform: rotate(-45deg);
`;

export const Badge = styled.div`
  background-color: ${(props) => props.color || "#008331"};
  border-radius: 4px;
  color: white;
  padding: 4px;
  font-weight: bold;
  text-align: center;
  font-size: 12px;
  display: inline-block;
`;

// -- Composite UI component --

export const IconWithTooltip = ({ id, iconName, tooltipContent, tooltipPosition = "top", iconStyle = {}, wrapperColor = "#f2f2f2" }) => {
  return (
    <IconWrapper color={wrapperColor}>
      <Icon
        name={iconName}
        id={id}
        style={{ width: "14px", blockSize: "1.1rem", verticalAlign: "middle", ...iconStyle }}
        aria-label={iconName}
        alt={iconName}
        size="Large"
        color="#000000"
      />
      <Tooltip target={`#${id}`} content={tooltipContent} position={tooltipPosition} />
    </IconWrapper>
  );
};
